<template>
  <div class="select-autocomplete">
    <div 
      :class="name == 'stepSelector' ? 'select-row-col' : 'select-row'"
      v-for="(result, index) in searchResults" 
      :key="result.stepID"
      @click="selectStep(index)"
    >
      <span class="main-step">{{result.name}}</span>
      <span class="equipment-step">{{result.equipment}}</span>
      <span class="equipment-step">{{result.stepID}}</span>
    </div>
  </div>
</template>

<script>
  export default {
    components: {
    },
    props: {
      searchResults: Array,
      name: String
    },
    data() {
      return {
      }
    }, 
    mounted() {
    },
    methods: {
      selectStep(index) {
        this.$emit('selectedStep', this.searchResults[index])
      },
    },
  }
</script>

<style lang="scss" scoped>
@import "@/style/base";
@import "@/style/components/buttons";
@import "@/style/components/modals";
@import "@/style/components/autocompleteList";

.select-row-col{
  padding: 12px 4px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  .main-step {
    width: 100%;
    display: inline-block;
    font-size: 12px !important;
    font-weight: 300;
    text-align: left;
    color: #707070;
    margin-bottom: 0 !important;
    width: auto;
  }

  .equipment-step {
    display: inline-block;
    font-weight: 300;
    text-align: left;
    color: #c6c6c6;
    margin-left: 4px;
    margin-bottom: 0 !important;
    width: auto;
    width: 100%;
    font-size: 12px !important;
  }
}
</style>
